export default __webpack_public_path__ + "static/media/assetSample7@3x.bdf3db15.png";